declare namespace $ {

	export class $rise_demo extends $mol_app_demo {
		Devtools( ): $rise_devtools_plugin
		menu_title( ): string
		sources_uri( ): string
		plugins( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=demo.view.tree.d.ts.map